import React from 'react';

import PropTypes from 'prop-types';

import {
    Section,
    TableOfContents,
    TableOfContentsItem,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

function TableOfContentsSection(props) {
    const {
        t,
        namespace,
        className,
        navItems = [],
    } = props;

    return (
        <Section className={className}>
            <TableOfContents>
                {navItems.map(({ anchor, text }) => (
                    <TableOfContentsItem
                        href={anchor}
                        key={anchor}
                        text={t(`${namespace}:${text}`)}
                    />
                ))}
            </TableOfContents>
        </Section>
    );
}

TableOfContentsSection.propTypes = {
    className: PropTypes.string,
    namespace: PropTypes.string.isRequired,
    navItems: PropTypes.arrayOf(PropTypes.object),
};

export { TableOfContentsSection };
export default localize(TableOfContentsSection);
